import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {Subject} from "rxjs";
import {ActivityI, TaskI, TaskStatus} from "../../../../infrastructure/interfaces/task.interface";
import {InfoTokenService, TranslateService} from "@mangosoft/mango-layout";

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss']
})
export class CalendarComponent  implements OnChanges, OnDestroy, OnInit {
  destroy$ = new Subject<void>();

  taskStatus = TaskStatus

  @Input() activityData: ActivityI | null = null;
  @Input() taskData: TaskI | null = null;
  @Output() newAppointment: EventEmitter<any> = new EventEmitter<any>();

  language: string = "es";
  token!: string;

  constructor(
    private translateService: TranslateService,
    private authService: InfoTokenService
  ) {
  }

  ngOnInit() {
    this.token = this.authService.getToken();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["taskData"]) {
      this.taskData = changes["taskData"]["currentValue"]
    }

    if (changes["activityData"]) {
      this.activityData = changes["activityData"]["currentValue"]
      const calendarData = {
        backendApiUrl: this.activityData?.api,
        language: this.language,
        resourceId: this.activityData?.metadata?.resourceId || '',
        eventTypeId: this.activityData?.metadata?.eventTypeId || null,
        isRoot: this.activityData?.calendarRoot || false,
        token: this.token,
        resource: this.activityData?.metadata?.resource || null,
        editEvent: this.activityData?.calendarEdit || false,
        initStatus: this.activityData?.calendarStatus || 'pending',
        eventId: this.activityData?.metadata?.eventId
      }
      console.log("Data injected calendar => ", calendarData)
    }
  }

  onNewAppointment(event: any) {
    console.log("Appointment data => ", event);
    if (event?.detail?.event?.data){
      this.newAppointment.emit(event);
    }
  }
}
